import { RenderSceneApi } from "../api/3d/RenderSceneApi/RenderSceneApi";
import { IRenderSceneConfigData } from "../api/3d/RenderSceneApi/type";
import { StatusName } from "../api/type";
import { IConfigImageSceneData } from "./type";

export class RenderSceneService {
  private renderSceneApi: RenderSceneApi = new RenderSceneApi();

  public async renderImage(data: IRenderSceneConfigData) {
    const response = await this.renderSceneApi.renderImage(data);

    return response.data;
  }

  public async getImageSceneData(
    data: IRenderSceneConfigData
  ): Promise<IConfigImageSceneData> {
    const response = await this.renderImage(data);

    if (response.status === StatusName.SUCCESS) {
      return {
        url: response.imageUrl,
        status: response.status,
      };
    }

    return {
      hash: response.configHash,
      status: response.status,
    };
  }
}
